import {
  bannerHeight,
  filterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import styled, { css } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FlexAlign } from '../Flex'
import { GridColumn, GridHeader, GridRow } from './Grid'

export const CenteredGridColumn = styled(GridColumn)`
  justify-content: center;
`

export const NoPaddingGridColumn = styled(GridColumn)`
  padding: 0px;
`

export const StickyGridHeader = styled(GridHeader).attrs(
  ({ $top, $bannerCount }: { $top?: number; $bannerCount: number }) => ({
    top: $top
      ? $top
      : headerContentHeight + filterBarHeight + $bannerCount * bannerHeight,
  }),
)<{ $gridAlign?: FlexAlign; $top?: number; $bannerCount?: number }>`
  position: sticky;
  z-index: 1;
  ${({ $gridAlign }) => {
    if (!$gridAlign) return ''
    return `justify-content: ${$gridAlign};`
  }}
`

export const StyledAccordionGridRow = styled(GridRow)<{
  isExpanded?: boolean
}>`
  cursor: pointer;

  .grid-column {
    margin-bottom: 8px;
    border-top: 1px solid ${palette.neutral['100']};
    border-bottom: 1px solid ${palette.neutral['100']};
    overflow: hidden;
  }

  .grid-column:first-child {
    border-left: 1px solid ${palette.neutral['100']};
  }

  .grid-column:last-child {
    border-right: 1px solid ${palette.neutral['100']};
  }

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      .grid-column {
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin-bottom: 0;
      }
    `}
`

export const StyledAccordionGridRowContent = styled.div`
  grid-column: 1 / -1;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border: 1px solid ${palette.neutral['100']};
  border-top: none;
  margin-bottom: 8px;
`

// Highlight for an open accordion row: the row and its expanded panel read as one
// bordered card. Shared by the framework-requirements grid and the user-role
// feature grid so the two stay identical.
export const ACTIVE_ACCORDION_BORDER_COLOR = '#2196f3'

export const StyledActiveAccordionGridRow = styled(StyledAccordionGridRow)`
  ${({ isExpanded }) =>
    isExpanded &&
    css`
      && .grid-column {
        border-top-color: ${ACTIVE_ACCORDION_BORDER_COLOR};
      }
      && .grid-column:first-child {
        border-left-color: ${ACTIVE_ACCORDION_BORDER_COLOR};
      }
      && .grid-column:last-child {
        border-right-color: ${ACTIVE_ACCORDION_BORDER_COLOR};
      }
    `}
`

export const ActiveAccordionGridRowContent = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px;
  margin-bottom: 8px;
  border-left: 1px solid ${ACTIVE_ACCORDION_BORDER_COLOR};
  border-right: 1px solid ${ACTIVE_ACCORDION_BORDER_COLOR};
  border-bottom: 1px solid ${ACTIVE_ACCORDION_BORDER_COLOR};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`
